import { render, staticRenderFns } from "./modifyProject.vue?vue&type=template&id=76712d72&"
import script from "./modifyProject.vue?vue&type=script&lang=js&"
export * from "./modifyProject.vue?vue&type=script&lang=js&"
import style0 from "./modifyProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports